export default __webpack_public_path__ + "static/media/main_saying02_jp.86cf77a4.png";